import React from 'react';
import { Box, BodyText } from 'modules/styled';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { getTimestamp, abbreviateNumber } from 'utils/numbers';

export const OLDEST_BET = gql`
  {
    oldestBet {
      createdAt
      stakedTokens
    }
  }
`;

export function NextUnlock() {
  const { data } = useQuery(OLDEST_BET);
  if (!data?.oldestBet?.stakedTokens) return null;
  const date = new Date(data?.oldestBet?.createdAt);
  date.setDate(date.getDate() + 3);
  const time = getTimestamp(date);
  return (
    <Box>
      <BodyText>
        {abbreviateNumber(data.oldestBet.stakedTokens)} coins will be unlocked{' '}
        {time.toLowerCase()}.
      </BodyText>
    </Box>
  );
}
